import { Component, Input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { DevicePendingActionState, DeviceValueUnit } from '@birco/rainmesh-api';
import { RelativeDatePipe } from '../../../../shared/pipes/relative-date.pipe';
import { LocalizedNumberPipe } from '../../../../shared/pipes/localized-number.pipe';
import { LocalizedPercentPipe } from '../../../../shared/pipes/localized-percent.pipe';
import { LabelConverter } from '../../../../shared/converter/label.converter';
import { PowerItemComponent } from '../power-item/power-item.component';
import { DeviceResponseDto } from '../../models/device-response.interface';

@Component({
  selector: 'app-device-info-table',
  imports: [
    TranslatePipe,
    RelativeDatePipe,
    LocalizedNumberPipe,
    LocalizedPercentPipe,
    PowerItemComponent,
  ],
  templateUrl: './device-info-table.component.html',
  styleUrl: './device-info-table.component.scss',
})
export class DeviceInfoTableComponent {
  @Input() device!: DeviceResponseDto;

  isActiveValue(value: string | boolean | null | undefined): boolean {
    return value === true || value === 'true';
  }

  getPendingStateLabelKey(
    state: DevicePendingActionState | null | undefined,
  ): string {
    return `devices.detail.pendingState.${state ?? 'UNKNOWN'}`;
  }

  isJson(str: string | null | undefined): boolean {
    if (typeof str !== 'string') return false;
    try {
      const parsed = JSON.parse(str);
      return typeof parsed === typeof {} || typeof parsed === typeof [];
    } catch (e) {
      return false;
    }
  }

  protected readonly DeviceValueUnit = DeviceValueUnit;
  protected readonly DevicePendingActionState = DevicePendingActionState;
  protected readonly LabelConverter = LabelConverter;
  protected readonly Number = Number;
  protected readonly JSON = JSON;
}
